module.exports = __webpack_public_path__ + "static/media/new_york.b97e0ca8.png";